import { Container, Grid, Slide, Typography, Box, Card, useTheme } from "@mui/material";
import Page from "../Page";
import aboutUs01 from "../../image/aboutUs01.jpeg";
import { DomainText } from "../chargeMiles/DomainText";

export default function AboutUs() {
  const theme = useTheme();

  return (
    <Page title="About Us | ChargeMiles" sx={{ marginTop: { xs: "128px", md: "62px" }, overflow: "hidden", minHeight: '100vh', pb: 10 }}>
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden" 
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              color: '#fff',
              p: { xs: 4, md: 6 },
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" fontWeight={700} gutterBottom>
              About Us
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.85, maxWidth: 600, mx: 'auto' }}>
              Providing the best experience for charging point services with our diverse expertise.
            </Typography>
          </Box>

          <Box sx={{ p: { xs: 3, md: 6, lg: 8 } }}>
            <Grid container alignItems="center" spacing={6}>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" fontWeight={600} gutterBottom color="text.primary" sx={{ lineHeight: 1.3, mb: 3 }}>
                  Who We Are
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph sx={{ lineHeight: 1.8 }}>
                  <DomainText /> is a company formed by a diverse team who have 
                  extensive expertise and experience in Utilities, Electric Vehicle Industry, 
                  smart metering, energy distribution and digital transformation and consulting.
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph sx={{ lineHeight: 1.8 }}>
                  The team has proven entrepreneur skills as demonstrated while building an 
                  independent fleet management solution ’Fleetomize’ using open-source technologies.
                </Typography>

                <Grid container spacing={4} sx={{ mt: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 3, bgcolor: 'rgba(145,158,171,0.08)', borderRadius: 2, height: '100%' }}>
                      <Typography variant="h3" color="primary.main" fontWeight={700} gutterBottom>
                        10+
                      </Typography>
                      <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                        Smart Utility Expertise
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 3, bgcolor: 'rgba(145,158,171,0.08)', borderRadius: 2, height: '100%' }}>
                      <Typography variant="h3" color="primary.main" fontWeight={700} gutterBottom>
                        40
                      </Typography>
                      <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                        Years Of Experience
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <Slide direction="left" in={true} timeout={{ appear: 1000, enter: 1000 }}>
                  <Box sx={{ 
                    borderRadius: 3, 
                    overflow: 'hidden', 
                    boxShadow: `0 24px 48px 0 rgba(145,158,171,0.24)`,
                    transform: 'translateZ(0)' // Hardware acceleration
                  }}>
                    <img src={aboutUs01} alt="About Us" style={{ width: '100%', height: 'auto', display: 'block' }} />
                  </Box>
                </Slide>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
